<section class="section" id="contact">
  <div class="container contact">
    <div class="section-box">
      <div class="mb-4" data-aos="fade-up" data-aos-duration="1000">
        <h3 class="contact-pre-title big-subtitle">05. And...Now?</h3>
        <h4 class="e-font contact-title big-title">Slide in!</h4>
      </div>
      <p data-aos="fade-up" data-aos-duration="1000">
        Hit me up if you wanna vibe on some new opportunities. Drop me a line,
        and I'll get back at you ASAP. Let’s make moves!
      </p>
      <div class="mt-5">
        <a
          href="mailto:mabubakarinbox@gmail.com"
          target="_blank"
          class="main-btn"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          Shoot Your Shot!
        </a>
      </div>
    </div>
  </div>
</section>
